module.exports = __webpack_public_path__ + "static/media/mobile-iphone.fa896ac2.svg";